import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref, onMounted } from "vue";
import { TransferBusStop } from "@/domain/entities/busStop";
import { useGetTransBusNumber } from "@/use/useGetTransBusNumber";
import InfoModal from "@/components/shared/modal/base/InfoModal.vue";


const __default__ = {
  name: "TransBusStop",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  transferBusStops: {
    type: Array as PropType<TransferBusStop[]>,
  },
  transferGuide: {
    type: String,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const showTransferBusStopGuide = ref(false);
const showParsedModalText = ref(false);
const transferableBusStop = ref("");
const transferBusGuide = ref("");

const toggleTransferBusStopGuide = (Yn: boolean) => {
  showTransferBusStopGuide.value = Yn;
};

const setTransBusInfo = () => {
  // 예외처리
  if (!props.transferGuide || !props.transferGuide.includes("하차 구성원"))
    return;
  const parseText = props.transferGuide.split("하차 구성원");
  if (parseText.length > 2) return;

  showParsedModalText.value = true;
  transferableBusStop.value = parseText[0];
  transferBusGuide.value = "하차 구성원" + parseText[1];
};

onMounted(() => {
  setTransBusInfo();
});

const __returned__ = { props, showTransferBusStopGuide, showParsedModalText, transferableBusStop, transferBusGuide, toggleTransferBusStopGuide, setTransBusInfo, get useGetTransBusNumber() { return useGetTransBusNumber }, InfoModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})